module.exports = __webpack_public_path__ + "static/media/Frida_1_t.5a431607.jpg";